import { DELETE_DESIGN, DELETE_DESIGN_FAIL, DELETE_DESIGN_SUCCESS, GET_DESIGN, GET_DESIGN_FAIL, GET_DESIGN_SUCCESS, UPLOAD_DESIGN, UPLOAD_DESIGN_FAIL, UPLOAD_DESIGN_SUCCESS } from "./Constants"

export const uploadDesign = (payload) => {
    return {
        type: UPLOAD_DESIGN,
        payload
    }
}

export const uploadDesignSuccess = payload => {
    return {
        type: UPLOAD_DESIGN_SUCCESS,
        payload
    }
}

export const uploadDesignFail = payload => ({
    type: UPLOAD_DESIGN_FAIL,
    payload
})

export const getDesigns = () => ({
    type: GET_DESIGN
})

export const getDesignsSuccess = payload =>({
    type: GET_DESIGN_SUCCESS,
    payload
})

export const getDesignsFail = payload =>({
    type: GET_DESIGN_FAIL,
    payload
})

export const deleteDesign = payload =>({
    type: DELETE_DESIGN,
    payload
})

export const deleteDesignSuccess = payload =>({
    type: DELETE_DESIGN_SUCCESS,
    payload
})

export const deleteDesignFail = payload =>({
    type: DELETE_DESIGN_FAIL,
    payload
})